import { useContext, useState } from 'react'
import { Paper, Typography, useMediaQuery } from '@mui/material'

import { VibioThemeContext } from '../../../../../context/VibioThemeProvider'

const fontStyleMap = {
    REGULAR: 0,
    MONO: 1,
    PLAYFUL: 2,
    ELEGANT: 3,
    BOLD: 4,
}

export default function FontDesign({ themeId, fontStyle }) {
    const isMobile = useMediaQuery('(max-width:1050px)')
    const [selectedFont, setSelectedFont] = useState(fontStyleMap[fontStyle])
    const [showUpdateSuccess, setShowUpdateSuccess] = useState(false)
    const { saveThemeChange } = useContext(VibioThemeContext)

    const fontStyles = [
        { value: 0, name: 'Regular', fontFamily: 'Catamaran' },
        { value: 3, name: 'Elegant', fontFamily: 'Times New Roman' },
        { value: 4, name: 'Bold', fontFamily: 'Bevan' },
        { value: 1, name: 'Monospace', fontFamily: 'monospace' },
        { value: 2, name: 'Playful', fontFamily: 'Comic Neue' },
    ]

    const styles = {
        paper: { p: 4, m: isMobile ? '1rem 0' : 2, borderRadius: '30px' },
        heading: { fontWeight: 600, fontFamily: 'inherit', mb: '1rem' },
        successText: { fontWeight: 500, fontFamily: 'inherit', color: 'green', mx: 1, display: 'inline' },
        section: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'flex-start',
            m: 0,
            p: '0 0 1rem 0',
        },
        label: { margin: '0 .8rem 0 0', padding: isMobile ? '.4rem 0' : 0 },
        fontName: (fontValue) => ({
            display: 'inline',
            fontWeight: fontValue === 2 ? 700 : 500,
            fontFamily: fontStyles.find(f => f.value === fontValue).fontFamily,
        }),
    }

    const getFontFromCode = (code) => {
        switch (Number(code)) {
            case 0: return 'REGULAR'
            case 1: return 'MONO'
            case 2: return 'PLAYFUL'
            case 3: return 'ELEGANT'
            case 4: return 'BOLD'
            default: return 'REGULAR'
        }
    }

    const handleFontStyleChange = (newFontStyle) => {
        newFontStyle = Number(newFontStyle)
        setSelectedFont(newFontStyle)
        saveThemeChange({ fontStyle: getFontFromCode(newFontStyle) })
        setShowUpdateSuccess(true)
        setTimeout(() => setShowUpdateSuccess(false), 550)
    }

    return (
        <Paper elevation={3} sx={styles.paper}>
            <Typography variant="h6" component="h6" sx={styles.heading}>
                Font Design
                {showUpdateSuccess && <Typography variant="body1" component="p" sx={styles.successText}>Change saved!</Typography>}
            </Typography>

            <section style={styles.section}>
                {fontStyles.map(font => (
                    <label key={font.value} style={styles.label}>
                        <input
                            type="radio"
                            name="font"
                            value={font.value}
                            checked={selectedFont === font.value}
                            onChange={(e) => handleFontStyleChange(e.target.value)}
                        />
                        <Typography variant="h6" component="h6" sx={styles.fontName(font.value)}>
                            {font.name}
                        </Typography>
                    </label>
                ))}
            </section>
        </Paper>
    )
}
